import { Root } from "./Root";
import { Row } from "./Row";
import { Body } from "./Body";
import { Cell } from "./Cell";

export const Table = {
    Root,
    Row,
    Body,
    Cell
};
